const dotenv = require('dotenv');
const nodeEnv = process.env.NODE_ENV || 'development';
const config = dotenv.config({ path: `.${nodeEnv}.env` });

/**
 * @type {import('next').NextConfig}
 */
const nextConfig = {
  assetPrefix: process.env.BUNDLE_URL,
  compiler: {
    styledComponents: {
      ssr: true,
      minify: true,
      pure: true,
    },
  },
  env: config.parsed,
  images: {
    loader: 'default',
    minimumCacheTTL: 31536000,
    domains: Object.keys(process.env)
      .filter((env) => env.includes('CDN_DOMAINS'))
      .map((env) => process.env[env]),
  },
};

if (process.env.NODE_ENV === 'production') {
  nextConfig.compress = true;
  nextConfig.compiler.removeConsole = {
    exclude: ['error'],
  };
  nextConfig.distDir = 'build/client';
  nextConfig.experimental = {
    modularizeImports: {
      lodash: {
        transform: 'lodash/{{member}}',
      },
    },
  };
  nextConfig.productionBrowserSourceMaps = true;
  nextConfig.swcMinify = true;
}

module.exports = nextConfig;
